export const MEDIA_L = 1312;
export const MEDIA_ML = 900;
export const MEDIA_M = 768;
export const MEDIA_S = 586;
